/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateOrganizationRequestSubscription
 */
export interface CreateOrganizationRequestSubscription {
    /**
     * 
     * @type {string}
     * @memberof CreateOrganizationRequestSubscription
     */
    plan?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateOrganizationRequestSubscription
     */
    locationPlan?: CreateOrganizationRequestSubscriptionLocationPlanEnum;
    /**
     * 
     * @type {string}
     * @memberof CreateOrganizationRequestSubscription
     */
    reservationsPlan?: CreateOrganizationRequestSubscriptionReservationsPlanEnum;
    /**
     * 
     * @type {string}
     * @memberof CreateOrganizationRequestSubscription
     */
    paymentFrequency: CreateOrganizationRequestSubscriptionPaymentFrequencyEnum;
}


/**
 * @export
 */
export const CreateOrganizationRequestSubscriptionLocationPlanEnum = {
    Starter: 'starter',
    Growth: 'growth',
    Unlimited: 'unlimited'
} as const;
export type CreateOrganizationRequestSubscriptionLocationPlanEnum = typeof CreateOrganizationRequestSubscriptionLocationPlanEnum[keyof typeof CreateOrganizationRequestSubscriptionLocationPlanEnum];

/**
 * @export
 */
export const CreateOrganizationRequestSubscriptionReservationsPlanEnum = {
    Basic: 'basic',
    Core: 'core',
    Premium: 'premium'
} as const;
export type CreateOrganizationRequestSubscriptionReservationsPlanEnum = typeof CreateOrganizationRequestSubscriptionReservationsPlanEnum[keyof typeof CreateOrganizationRequestSubscriptionReservationsPlanEnum];

/**
 * @export
 */
export const CreateOrganizationRequestSubscriptionPaymentFrequencyEnum = {
    Monthly: 'monthly',
    Yearly: 'yearly'
} as const;
export type CreateOrganizationRequestSubscriptionPaymentFrequencyEnum = typeof CreateOrganizationRequestSubscriptionPaymentFrequencyEnum[keyof typeof CreateOrganizationRequestSubscriptionPaymentFrequencyEnum];


/**
 * Check if a given object implements the CreateOrganizationRequestSubscription interface.
 */
export function instanceOfCreateOrganizationRequestSubscription(value: object): value is CreateOrganizationRequestSubscription {
    if (!('paymentFrequency' in value) || value['paymentFrequency'] === undefined) return false;
    return true;
}

export function CreateOrganizationRequestSubscriptionFromJSON(json: any): CreateOrganizationRequestSubscription {
    return CreateOrganizationRequestSubscriptionFromJSONTyped(json, false);
}

export function CreateOrganizationRequestSubscriptionFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateOrganizationRequestSubscription {
    if (json == null) {
        return json;
    }
    return {
        
        'plan': json['plan'] == null ? undefined : json['plan'],
        'locationPlan': json['locationPlan'] == null ? undefined : json['locationPlan'],
        'reservationsPlan': json['reservationsPlan'] == null ? undefined : json['reservationsPlan'],
        'paymentFrequency': json['paymentFrequency'],
    };
}

export function CreateOrganizationRequestSubscriptionToJSON(json: any): CreateOrganizationRequestSubscription {
    return CreateOrganizationRequestSubscriptionToJSONTyped(json, false);
}

export function CreateOrganizationRequestSubscriptionToJSONTyped(value?: CreateOrganizationRequestSubscription | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'plan': value['plan'],
        'locationPlan': value['locationPlan'],
        'reservationsPlan': value['reservationsPlan'],
        'paymentFrequency': value['paymentFrequency'],
    };
}

